/**
 * 活动牛币（每日签到 / 新手任务）相关常量。
 * 与 /json/newbie-task/* 、/json/sign-in/* 接口约定保持一致。
 */

/** 新手任务业务功能类型，作为 /json/newbie-task/complete 的 bizType 入参 */
export const NEWBIE_TASK_BIZ_TYPE = {
  /** 查看纪要 */
  VIEW_SUMMARY: 1,
  /** 查看外资研报 */
  VIEW_FOREIGN_REPORT: 2,
  /** AI 进宝聊天模式 */
  AI_CHAT_MODE: 3,
  /** AI 进宝研究模式（仅 BRM） */
  AI_RESEARCH_MODE: 4,
  /** AI 进宝任务模式 */
  AI_TASK_MODE: 5,
  /** 浏览自选（个股 / 行业 / 产业链详情页） */
  VIEW_WATCHLIST: 6,
  /** 查看内参（内参热点详情） */
  VIEW_INSIGHT: 7
};

/** 签到规则兜底值：接口未下发时按此展示，避免面板出现空白 */
export const SIGN_IN_RULE_FALLBACK = {
  /** 连续签到周期天数 */
  cycleDays: 5,
  /** 每日签到奖励牛币 */
  dailyRewardNbi: 10,
  /** 满周期奖励牛币 */
  cycleRewardNbi: 50
};

/** 活动牛币有效天数：接口未下发该配置，规则说明按产品约定固定展示 30 天 */
export const ACTIVITY_NBI_VALID_DAYS = 30;

/** 活动牛币变动事件名：签到成功、新手任务完成后广播，供余额/面板类组件刷新 */
export const ACTIVITY_NBI_UPDATED_EVENT = 'activity-nbi-updated';
